import * as React from 'react';
import { Text, TextTypography } from '../Text';
import { st, classes } from './DropdownOption.deprecated.st.css';
import { DropdownOptionTextOverflow } from './types';
import { DATA_HOOKS } from './constants';
import { createOptionLabelId } from './helpers';
export const DropdownOption = (props) => {
    const { value, id, isSelectable, subtitle, icon, suffix, isSectionTitle, className, unavailable, indentIcon, textOverflow = DropdownOptionTextOverflow.ellipsis, descendantId, isFocused, } = props;
    const ref = React.useRef(null);
    React.useEffect(() => {
        if (isFocused && ref.current) {
            ref.current.scrollIntoView?.({ block: 'nearest' });
        }
    }, [isFocused]);
    return (React.createElement("div", { "data-hook": DATA_HOOKS.option, key: id, ref: ref, className: st(classes.root, {
            withIcon: !!icon,
            sectionTitle: isSectionTitle,
            selectable: isSelectable,
            unavailable: !!unavailable,
            indentIcon: !!indentIcon,
            textOverflow,
            isFocused,
        }, className) },
        icon && (React.createElement("div", { "data-hook": DATA_HOOKS.icon, className: classes.icon }, icon)),
        React.createElement("div", { className: classes.contentWrapper },
            React.createElement(Text, { className: classes.title, typography: TextTypography.runningText, id: descendantId && createOptionLabelId(descendantId), "aria-disabled": !(isSelectable && !unavailable) }, value),
            subtitle && (React.createElement(Text, { className: classes.subtitle, typography: TextTypography.runningText }, subtitle))),
        suffix && (React.createElement("div", { "data-hook": DATA_HOOKS.suffix, className: classes.suffix }, suffix))));
};
//# sourceMappingURL=DropdownOption.js.map